import * as React from 'react';
import { cn } from '@/lib/utils';

export interface StatusDotProps {
  status: 'connected' | 'disconnected' | 'processing' | 'ready' | 'failed' | 'ok' | 'degraded' | 'error';
  className?: string;
  label?: string;
}

const statusStyles = {
  connected: 'bg-green-500',
  disconnected: 'bg-gray-400',
  processing: 'bg-yellow-500 animate-pulse',
  ready: 'bg-green-500',
  failed: 'bg-red-500',
  ok: 'bg-green-500',
  degraded: 'bg-yellow-500',
  error: 'bg-red-500',
};

const statusLabels = {
  connected: 'Connected',
  disconnected: 'Disconnected',
  processing: 'Processing',
  ready: 'Ready',
  failed: 'Failed',
  ok: 'OK',
  degraded: 'Degraded',
  error: 'Error',
};

export const StatusDot = React.forwardRef<HTMLSpanElement, StatusDotProps>(
  ({ status, className, label }, ref) => {
    const ariaLabel = label || statusLabels[status];

    return (
      <span
        ref={ref}
        className={cn('inline-block h-2 w-2 rounded-full', statusStyles[status], className)}
        role="status"
        aria-label={ariaLabel}
        title={ariaLabel}
      />
    );
  }
);

StatusDot.displayName = 'StatusDot';
